import React from 'react';
import { css } from 'react-emotion';
import cx from 'classnames';

const paragraphStyle = css`
  font-size: 1rem;
`;

const smallStyle = css`
  font-size: .8rem;
`;

const P = props => {
  const className = cx(
    paragraphStyle,
    props.small && smallStyle
  );

  return (
    <div className={className} style={{ color: props.color, width: props.width }}>
      {props.children}
    </div>
  );
};


export default P;
